import { useLocation } from '@thd-olt-component-react/router';
import { parseUrl, updateQueryParams } from '../product-results-helpers';
import { useSafeNavigate } from './product-results-search-methods-PLP';

const targetPosition = (element) => {
  if (!element) return null;
  const currentPosition = window.scrollY || window.pageYOffset;
  return element.getBoundingClientRect().top + currentPosition;
};

// Standalone exported functions for testing
export const onDimensionsChangePEP = ({
  refinement,
  dimension,
  path,
  scrollToRef,
  navigate
}) => {
  const {
    redirectUrl, url, clear = false, refinementKey, dimensionName = dimension?.label
  } = refinement;
  const params = {
    ...parseUrl({ path }),
    ...parseUrl({ path: url }),
    Nao: 0
  };

  if (clear || (dimensionName && dimensionName === 'Price' && !refinementKey)) {
    params.lowerbound = '';
    params.upperbound = '';
  }

  const paramsObject = Object.keys(params)
    .map((param) => {
      return {
        paramName: param,
        paramValue: params[param]
      };
    })
    .filter((par) => {
      return !/category|context|slugs/.test(par.paramName);
    });
  const updatedUrl = redirectUrl || updateQueryParams(path, paramsObject);
  window.LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.click', refinement);
  const targetNode = scrollToRef && scrollToRef.current ? scrollToRef.current : null;
  let targetLocation = targetPosition(targetNode);
  window.scrollTo({
    top: targetLocation,
    behavior: 'smooth'
  });
  navigate(updatedUrl);
};

export const onSortChangePEP = ({
  sortby, sortorder, name, currentPage, page, path, navigate
}) => {
  const newPath = updateQueryParams(path, [
    {
      paramName: 'Nao',
      paramValue: null
    },
    {
      paramName: 'sortorder',
      paramValue: sortorder
    },
    {
      paramName: 'sortby',
      paramValue: sortby
    }
  ]);

  window.LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.click', {
    name,
    currentPage,
    page
  });
  navigate(newPath);
};

export const onPageChangePEP = ({
  page,
  path,
  pageSize,
  scrollToRef,
  navigate
}) => {
  const newPath = updateQueryParams(path, [
    {
      paramName: 'Nao',
      paramValue: (page - 1) * pageSize
    }
  ]);

  navigate(newPath);

  const targetNode = scrollToRef && scrollToRef.current ? scrollToRef.current : null;
  let targetLocation = targetPosition(targetNode);
  window.scrollTo({
    top: targetLocation,
    behavior: 'smooth'
  });
};

// PEP - Product Results Methods Hook
export function ProductResultsSearchMethodsPEP() {
  const navigate = useSafeNavigate();
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;

  return {
    onDimensionsChangePEP: (params) => onDimensionsChangePEP({ ...params, path, navigate }),
    onSortChangePEP: (params) => onSortChangePEP({ ...params, path, navigate }),
    onPageChangePEP: (params) => onPageChangePEP({ ...params, path, navigate })
  };
}